module.exports = __webpack_public_path__ + "img/nutrition_5.ff862223.jpg";